module.exports = __webpack_public_path__ + "static/media/ApiRest.35de0072.png";